<template>
  <span>
    <!-- Tab -->
    <div class="row">
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Parameter</label>
          <div class="col-sm-9">
            <my-select
              disableFormControl="true"
              :selection.sync="form.parameter_setup_id"
              :suggestions="parameterSetups"
              placeholder="Select Parameter"
            ></my-select>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Reading date</label>
          <div class="col-sm-9">
            <my-datepicker
              :date.sync="form.reading_date"
              placeholder="Enter Reading Date"
            ></my-datepicker>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Comments</label>
          <div class="col-sm-9">
            <input
              type="text"
              v-model="form.comments"
              class="form-control"
              placeholder="Comments"
            />
          </div>
        </div>
      </div>
    </div>
  </span>
</template>

<script type="text/javascript">
import axios from "axios";
export default {
  name: "ParameterSetupFormWidget",
  props: ["form"],
  data() {
    return {
      parameterSetups: [],
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("parameter_monitorings/masters");
      masters = masters.data;
      masters.parameter_setups.forEach((parameterSetup) => {
        this.parameterSetups.push({
          id: parameterSetup.id,
          name: parameterSetup.title,
        });
      });
    },
  },
};
</script>
